import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';

import { AutoLotView } from '../../../const';
import { LotTypeEnum, UserLotQuery } from '../../graphql/service/graphql-auto-main-service';
import { LotSource } from '../../graphql/service/graphql-cars-default-service';
import { LotAddPhotoModalComponent } from './components/modal/lot-add-photo-modal/lot-add-photo-modal.component';

@Component({
  selector: 'app-lot-add-photo-button',
  templateUrl: './lot-add-photo-button.component.html',
  styleUrls: ['./lot-add-photo-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotAddPhotoButtonComponent {
  @Input() lot: AutoLotView;
  @Input() lotType: LotTypeEnum;
  @Input() lotSource: LotSource;
  @Input()
  @HostBinding('class.full-size')
  fullSize = false;
  @Input()
  set currentUser(currentUser: UserLotQuery['currentUser']) {
    this.display = currentUser.isAuctioneer ? 'inline-block' : 'none';
  }

  @Output() completed = new EventEmitter<void>();

  @HostBinding('style.display') display: 'none' | 'inline-block' = 'none';

  constructor(private readonly modalService: NzModalService) {}

  openAddPhotoModal(): void {
    this.modalService.create({
      nzContent: LotAddPhotoModalComponent,
      nzWidth: '750px',
      nzComponentParams: {
        lot: this.lot,
        lotType: this.lotType,
        lotSource: this.lotSource,
        completed: this.completed,
      },
    });
  }
}
